import PropTypes from 'prop-types'
import styled from 'styled-components'
import { components } from 'react-select'

const StyledWrapper = styled.div`
  margin-right: 6px;
`

const MultiValueWithIcon = styled.div`
  display: flex;
  align-items: center;
}`

const MultiValue = (props) => {
  const { iconComponentsMap } = props.selectProps

  if (!iconComponentsMap) {
    return (
      <StyledWrapper {...props.innerProps}>
        <components.MultiValue {...props} />
      </StyledWrapper>
    )
  }

  const value = props.data.value
  const OptionComponent = () => iconComponentsMap[value] || null

  return (
    <StyledWrapper {...props.innerProps}>
      <MultiValueWithIcon>
        <OptionComponent />
        <components.MultiValue {...props} />
      </MultiValueWithIcon>
    </StyledWrapper>
  )
}

MultiValue.propTypes = {
  data: PropTypes.object,
  selectProps: PropTypes.object,
  innerProps: PropTypes.object,
}

export default MultiValue
